export default __webpack_public_path__ + "static/media/PAFI_Pemanggilan RUPS 2023.20f4858e.pdf";